var map = {
	"./employee-collage-0.jpg": 42918,
	"./employee-collage-1.jpg": 99330,
	"./employee-collage-2.jpg": 79606,
	"./employee-collage-225w-3.jpg": 69934,
	"./employee-collage-3.jpg": 10549,
	"./employee-collage-335w-1.jpg": 37069,
	"./employee-collage-335w-2.jpg": 57772,
	"./employee-collage-336w-0.jpg": 83853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32518;